import {Action} from '@ngrx/store';
import {Department} from '@app/core/models/department.model';
import {IDepartmentPostPayload} from '@app/core/services/api/department.service';

export enum EDepartmentActions {
	GetDepartments = '[Department] Get Department',
	GetDepartmentsSuccess = '[Department] Get Department Success',

	PostDepartment = '[Department] Post Department',
	PostDepartmentSuccess = '[Department] Post Department Success',
}

export class GetDepartments implements Action {
	public readonly type = EDepartmentActions.GetDepartments;

	constructor() {
	}
}

export class GetDepartmentsSuccess implements Action {
	public readonly type = EDepartmentActions.GetDepartmentsSuccess;

	constructor(public departments: Department[]) {
	}
}

export class PostDepartment implements Action {
	public readonly type = EDepartmentActions.PostDepartment;

	constructor(public payload: IDepartmentPostPayload) {
	}
}

export class PostDepartmentSuccess implements Action {
	public readonly type = EDepartmentActions.PostDepartmentSuccess;

	constructor(public department: Department) {
	}
}

export type DepartmentActions =
	GetDepartments |
	GetDepartmentsSuccess |
	PostDepartment |
	PostDepartmentSuccess
	;
